import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { GooeyFilter } from '../components/ui/gooey-filter';
import { PixelTrail } from '../components/ui/pixel-trail';
import { useScreenSize } from '../hooks/use-screen-size';
import ScrollReveal from '../components/ScrollReveal';

const stats = [
  { value: '150+', label: 'Clientes activos' },
  { value: '300+', label: 'Proyectos entregados' },
  { value: '8+', label: 'Años de experiencia' },
];

export default function Home() {
  const screenSize = useScreenSize();

  return (
    <div className="page">
      <section className="hero" style={{ position: 'relative' }}>
        {/* Pixel Trail Background */}
        <img
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1600&fit=crop"
          alt=""
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: 0.12,
          }}
        />
        <GooeyFilter id="gooey-hero" strength={5} />
        <div
          className="absolute inset-0 z-0"
          style={{ filter: 'url(#gooey-hero)' }}
        >
          <PixelTrail
            pixelSize={screenSize.lessThan('md') ? 24 : 32}
            fadeDuration={0}
            delay={500}
            pixelClassName="bg-neutral-900"
          />
        </div>

        <div className="container" style={{ position: 'relative', zIndex: 10 }}>
          <div className="hero-inner">
            <div className="hero-content">
              <ScrollReveal>
                <div className="hero-label">
                  <span className="dot-indicator" />
                  Agencia de marketing & diseño
                </div>
              </ScrollReveal>

              <ScrollReveal delay={0.1}>
                <h1>
                  Estrategia<br />
                  que <span className="gradient-text">vende.</span>
                </h1>
              </ScrollReveal>

              <ScrollReveal delay={0.2}>
                <p>
                  Diseñamos experiencias digitales que conectan marcas con personas.
                  Estrategia, creatividad y tecnología para llevar tu negocio al
                  siguiente nivel.
                </p>
              </ScrollReveal>

              <ScrollReveal delay={0.3}>
                <div className="hero-buttons">
                  <Link to="/contacto" className="btn btn-primary">
                    Comenzar proyecto <ArrowRight size={18} />
                  </Link>
                  <Link to="/portafolio" className="btn btn-outline">
                    Ver portafolio
                  </Link>
                </div>
              </ScrollReveal>
            </div>

            <ScrollReveal delay={0.2} direction="left">
              <div className="hero-image">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&fit=crop"
                  alt="Equipo colaborando en proyectos creativos"
                />
              </div>
            </ScrollReveal>
          </div>

          <div className="hero-stats">
            {stats.map(({ value, label }, i) => (
              <ScrollReveal key={label} delay={0.4 + i * 0.1}>
                <div className="stat-card">
                  <h3>{value}</h3>
                  <p>{label}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
